export default __webpack_public_path__ + "static/media/appNepar.c6208967.png";